import { Component, OnInit } from '@angular/core';
//import { AdataService } from '../../../shared/adata.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { UserService } from '../../shared/user.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-schemecreation',
  templateUrl: './schemecreation.component.html',
  styleUrls: ['./schemecreation.component.css']
})
export class SchemecreationComponent implements OnInit {

  title="Scheme Creation";

  data: any = {};
  DividendLedgerList: any;
  ChitRegistionList:any;
  SocietyContributionList:any;
  ChitFundPenalityList:any;
  ChitAccountList:any;
  ChitListDetails:any = [];
  c: any = {};
  DateValues:string;
  today = new Date(); 
  console: any;
  constructor(private service: UserService, private router: Router, private route: ActivatedRoute,private datePipe:DatePipe)
  { 

  }

  ngOnInit() {
    this.getDividendLedgerList();
    this. getChitRegistionList();
    this.SocietyContribution();
    this.ChitFundPenality();
    this.ChitAccount();
    this.GetAllChitDet();
    this.c.Chit_Start_Date=this.getdatefun(this.today);
  }
  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }

  getDividendLedgerList() {
    this.data = this.service.GetDividendLedger();
    this.data.subscribe(
      (response) => {
        this.DividendLedgerList = response.DividendLedger;
        console.log('DividendLedgerList');
        console.log(response);
      })
  }

  getChitRegistionList() {
    this.data = this.service.GetChitRegis();
    this.data.subscribe(
      (response) => {
        this.ChitRegistionList = response.DividendLedger;
        console.log('ChitRegistionList');
        console.log(response);
      })
  }

  SocietyContribution() {
    this.data = this.service.SocietyContribution();
    this.data.subscribe(
      (response) => {
        this.SocietyContributionList = response.DividendLedger;
        console.log('SocietyContributionList');
        console.log(response);
      })
  }

  ChitFundPenality() {
    this.data = this.service.ChitFundPenality();
    this.data.subscribe(
      (response) => {
        this.ChitFundPenalityList = response.DividendLedger;
        console.log('ChitFundPenalityList');
        console.log(response);
      })
  }

  getData(data:any)
  {
    debugger;
    let newDate=data.substring(8);
    this.c.Chit_Day=newDate;
  }


  ChitAccount() {
    debugger;
    this.data = this.service.ChitAccount();
    this.data.subscribe(
      (response) => {
        this.ChitAccountList = response.DividendLedger;     
      })
  }
  GetAllChitDet()
  {
    debugger;
    this.data = this.service.GetallChitlist();
    this.data.subscribe(
      (response: any) => 
      {
        this.ChitListDetails = response;
        console.log(this.ChitListDetails);
        //console.log('Caste List');
       
        for(var i=0;i<this.ChitListDetails.length;i++)
        {
          if(this.ChitListDetails[i].DESCRIPTION=='CHITCOMM')
          {
           
            this.c.COMMRate_Percetage=this.ChitListDetails[i].STAT;
            console.log(this.c.CHITCOMM);
           }

          if(this.ChitListDetails[i].DESCRIPTION=='CHITPEN')
          {
           
            this.c.Penality_Percetage=this.ChitListDetails[i].STAT;
            
           }

           if(this.ChitListDetails[i].DESCRIPTION =='CHITCTRL')
           {
             this.c.ControlAmt_Percetage=this.ChitListDetails[i].STAT;
           }
       }
        //document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        //document.getElementById('loader-spinner').style.display = "none";
      }
    );
    //this.getDetails();
     
  
}
SendData(Data:any)
{
  debugger;

  this.data = this.service.PostChitForm(this.c);
  this.data.subscribe(
    (response: any) => 
    {
      Swal('Success!', 'Chit  Added Successfully .', 'success');
      this.Cancel();
    },
    (error) => {

    }
  );

}

Cancel()
{
  this.c.NewChit_ID='';
  this.c.Abbrevation='';
  this.c.Normal_Double_Chit_Id='';
  this.c.Name='';
  this.c.Chit_Start_Date='';
  this.c.Name1='';
  this.c.Chit_Day='';
  this.c.Scheme_Amt='';
  this.c.No_of_Members='';
  this.c.L_CODE2='';
  this.c.L_CODE4='';
  this.c.L_CODE1='';
  this.c.L_CODE='';
  this.c.L_CODE3='';
  this.c.Remarks='';
  this.c.Reg_Date='';
  this.c.Reg_Amount='';
  this.c.Reg_No='';
  this.c.Dept_Remarks=''; 
  this.c.Penality_Percetage='';
  this.c.ControlAmt_Percetage='';
  this.c.COMMRate_Percetage='';
}
}



// WEBPACK FOOTER //
// ./src/app/chitfund/schemecreation/schemecreation.component.ts